module.exports = __webpack_public_path__ + "static/media/spray.e5e24a2b.svg";